<template>
  <div class="newsWrappper">
    <div
      class="bg-white"
      v-for="(item, index) in list.slice(0, 1)"
      :key="index"
    >
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="item1"
      >
        <ImageContainer
          class="img"
          :src="list[0].image.medium"
          :thumb="list[0].image.thumbnail"
          :alt="list[0].title"
        />
        <h2>{{ list[0].sub_category.name }}</h2>
        <h1>
          {{ list[0].title }}
        </h1>
        <h3>
          {{ handleDate(list[0].pub_date) }},
          {{ handleTime(list[0].pub_date) }}
        </h3>
      </router-link>
      <div
        class="changeImage"
        :style="{
          background: `url(${list[activeImage].image.medium})no-repeat center center /cover`,
        }"
      >
        <div
          v-for="(item, index) in list.slice(1, 4)"
          :key="index"
          class="blogs"
          @mouseover="activeImage = index"
          :class="{ activeImage: activeImage === index }"
        >
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          >
            <div class="content">
              <h2>{{ $t("medicine.subcategory") }}</h2>
              <h1>
                {{ item.title }}
              </h1>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="item1"
      >
        <ImageContainer
          class="img"
          :src="list[4].image.medium"
          :thumb="list[4].image.thumbnail"
          :alt="list[4].title"
        />
        <h2>{{ list[4].sub_category.name }}</h2>
        <h1>
          {{ list[4].title }}
        </h1>
        <h3>
          {{ handleDate(list[4].pub_date) }},
          {{ handleTime(list[4].pub_date) }}
        </h3>
      </router-link>
    </div>
    <div class="bg-whiteIpad">
      <div class="triangle left"></div>
      <div class="content" ref="ipadParent">
        <div
          class="ipadCont"
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: activeIndex === index }"
        >
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          >
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :alt="item.title"
              :thumb="item.image.thumbnail"
            />
            <div class="beforeContent">
              <h2>{{ item.sub_category.name }}</h2>
              <h1>
                {{ item.title }}
              </h1>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
      <div class="triangle right"></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    /* eslint-disable */
    const activeIndex = ref(0);
    const activeImage = ref(0);
    const ipadParent = ref(null);
    const offsets = [];
    let offsetElements = 0;

    const handleScroll = async () => {
      for (const elemIndex in offsets) {
        if (window.scrollY >= offsets[elemIndex]) {
          activeIndex.value = offsetElements - elemIndex - 1;
          return;
        }
      }
    };

    onMounted(() => {
      for (const ipadIndex in ipadParent.value.children) {
        const num = parseInt(ipadIndex);
        if (!Number.isNaN(num)) {
          offsets.unshift(ipadParent.value.children[ipadIndex].offsetTop - 220);
        }
      }

      offsetElements = offsets.length;

      if (typeof window !== "undefined") {
        window.addEventListener("scroll", handleScroll);
      }
    });

    const images = [
      "https://p4.wallpaperbetter.com/wallpaper/873/317/101/anime-girls-green-eyes-sky-anime-wallpaper-preview.jpg",
      "https://p4.wallpaperbetter.com/wallpaper/526/384/992/digital-art-artwork-anime-anime-girls-darling-in-the-franxx-hd-wallpaper-preview.jpg",
      "https://p4.wallpaperbetter.com/wallpaper/180/548/1015/anime-anime-girls-zero-two-darling-in-the-franxx-artwork-wallpaper-preview.jpg",
      "https://p4.wallpaperbetter.com/wallpaper/85/1002/493/night-zero-two-darling-in-the-franxx-ichigo-darling-in-the-franxx-black-clothes-pink-hair-hd-wallpaper-preview.jpg",
      "https://p4.wallpaperbetter.com/wallpaper/774/872/46/anime-darling-in-the-franxx-zero-two-darling-in-the-franxx-wallpaper-preview.jpg",
    ];

    return {
      activeIndex,
      ipadParent,
      activeImage,
      images,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.newsWrappper {
  width: 100%;
  .bg-white {
    background: var(--light);
    height: 16.3vw;
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    position: relative;
    .item1 {
      width: 16vw;
      height: 11.5vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .img {
        width: 50%;
        height: 5.6vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      h2 {
        font-size: 0.85vw;
        line-height: 1.3vw;
        font-weight: 400;
        color: var(--grey-t-color);
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        margin-bottom: 0.2vw;
        margin-top: 0.26vw;
      }
      h1 {
        font-size: 1.1vw;
        line-height: 1.3vw;
        font-weight: 400;
        color: var(--black-color);
        font-family: "Alice", serif;
        font-style: normal;
        margin-bottom: 0.313vw;
      }
      h3 {
        font-size: 0.85vw;
        line-height: 1.3vw;
        font-weight: 300;
        color: var(--grey-b-color);
        font-family: "Open Sans", sans-serif;
        font-style: normal;
      }
    }
    .changeImage {
      height: 18vw;
      width: 57vw;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow: hidden;
      margin-bottom: 1.6vw;
      border-top-left-radius: 2vw;
      border-top-right-radius: 2vw;
      object-fit: contain;
      cursor: pointer;
      .blogs {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 19vw;
        height: 18vw;
        position: relative;
        padding-left: 1vw;
        padding-right: 1vw;
        h2 {
          font-size: 0.85vw;
          line-height: 1.3vw;
          font-weight: 400;
          color: var(--light-b-color);
          font-family: "Open Sans", sans-serif;
          font-style: normal;
          margin-bottom: 0.2vw;
        }
        h1 {
          font-size: 1.1vw;
          line-height: 1.3vw;
          font-weight: 400;
          color: var(--light-m-color);
          font-family: "Alice", serif;
          font-style: normal;
        }
        h3 {
          font-size: 0.85vw;
          line-height: 1.3vw;
          font-weight: 300;
          color: var(--light-b-color);
          font-family: "Open Sans", sans-serif;
          font-style: normal;
        }
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: black;
          opacity: 0;
          transition: all 0.4s;
        }
        &:hover:before {
          opacity: 0.6;
        }
        &:hover > .content {
          transform: translateY(-10px);
          transition: all 0.4s;
        }
        .content {
          position: relative;
          z-index: 2;
        }
      }
    }
  }
  .bg-whiteIpad {
    display: none;
  }
}

@media screen and (max-width: 1366px) {
  .newsWrappper {
    .bg-white {
      display: none;
    }

    .bg-whiteIpad {
      width: 100%;
      display: flex;

      .content {
        flex: 1 0 0;
        display: flex;
        align-items: center;
        flex-direction: column;

        .ipadCont {
          position: relative;
          width: 82vw;
          height: 62vw;
          overflow: hidden;

          .img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          .beforeContent {
            position: relative;
            padding: 0 10%;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.5),
              rgba(0, 0, 0, 0.5)
            );
            text-align: center;
            opacity: 0;
            transition: all 0.4s ease;
            padding-left: 18vw;
            padding-right: 18vw;

            h2 {
              font-size: 1.7vw;
              line-height: 2vw;
              font-weight: 600;
              color: var(--light-t-color);
              font-family: "Open Sans", sans-serif;
              font-style: normal;
            }
            h1 {
              font-size: 2.1vw;
              line-height: 2vw;
              font-weight: 600;
              font-family: "Source Serif Pro", serif;
              font-style: normal;
              margin-top: 1vw;
              margin-bottom: 1vw;
            }
            h3 {
              font-size: 1.7vw;
              line-height: 2vw;
              font-weight: 300;
              font-family: "Open Sans", sans-serif;
              font-style: normal;
            }
          }

          &.active {
            .beforeContent {
              opacity: 1;
            }
          }

          &:first-child {
            border-top-right-radius: 1.25rem;
            border-top-left-radius: 1.25rem;
          }

          &:last-child {
            border-bottom-right-radius: 1.25rem;
            border-bottom-left-radius: 1.25rem;
          }
        }
      }

      .triangle {
        top: 15vw;
        position: sticky;
        width: 0;
        height: 0;
        border-top: 5vw solid transparent;
        border-bottom: 5vw solid transparent;

        &.left {
          border-left: 5vw solid var(--light-t-color);
        }

        &.right {
          border-right: 5vw solid var(--light-t-color);
        }
      }
    }
  }
}
</style>